import React from 'react';
import { Icon } from 'common/components';
import { ICON_COLLECTION } from 'assets/media/icons';
import './ErrorHeaderRenderer.scss';

type ErrorHeaderRendererProps = {
    displayName: string;
    count: number;
    isAtleastOneErrorFixed: boolean;
};

const ErrorHeaderRenderer = ({
    displayName,
    count,
    isAtleastOneErrorFixed
}: ErrorHeaderRendererProps) => {
    return (
        <div className="header-title">
            {displayName}
            {count > 0 ? (
                <>
                    <Icon className="error-cell-icon info-icon" src={ICON_COLLECTION.IC_Info} />
                    <span className="total-count">{count}</span>
                </>
            ) : isAtleastOneErrorFixed && count === 0 ? (
                <Icon className="error-fixed" src={ICON_COLLECTION.IC_Success_Filled} />
            ) : null}
        </div>
    );
};

export default ErrorHeaderRenderer;
